module.exports = __webpack_public_path__ + "static/media/available.32aed385.svg";